import React, { useContext } from 'react'
import withData from './withData'
import { INodeProps } from '../lib/legoParser'
import { getCampaignContent } from '../services/legoService'
import { ComponentsContext } from '../lib/context'

export interface clickProp {
  pid?: string
  clickTo?: Function
  withData?: Function
  getCampaignContent?: Function
  OutLine?: typeof React.Component
}
const TreeNode = (props: INodeProps & clickProp) => {
  const csContext = useContext(ComponentsContext)
  const {
    id,
    pid,
    render,
    childrens,
    config,
    clickTo,
    OutLine,
    ...otherProps
  } = props
  const DOMprops = {
    id,
    pid,
    render,
    config,
    clickTo,
    childrens,
    OutLine,
    ...otherProps,
  }
  if (render === 'Conference') {
    //是大会场，需要处理数据
    DOMprops.withData = withData
    DOMprops.getCampaignContent = getCampaignContent
  }
  if (OutLine) {
    return (
      <OutLine {...DOMprops} key={id}>
        {React.createElement(
          render && csContext && csContext[render] ? csContext[render] : 'div',
          DOMprops,
          childrens && childrens.length > 0
            ? childrens.map((c: INodeProps) =>
                TreeNode({ ...c, clickTo, OutLine })
              )
            : <></>
        )}
      </OutLine>
    )
  }
  return React.createElement(
    render && csContext && csContext[render] ? csContext[render] : 'div',
    DOMprops,
    childrens && childrens.length > 0
      ? childrens.map((c: INodeProps) => TreeNode({ ...c, clickTo }))
      : <></>
  )
}

export default TreeNode
